import { Injectable } from '@angular/core';
import { EChartsOption } from 'echarts';
import { Observable, Subject } from 'rxjs';
import { ChartConfig, ClimateChart, YAxis } from '../../../model/climate/climate-chart';
import { MAPTYCS_CHART_COLOR, COPERNICUS_RED_COLOR, getSSPColor } from './custom-theme';
import { ClimateChartHelper } from './util/climate-chart-helper';

@Injectable()
export class TxxScoreService {

  private readonly locationChartSubject: Subject<any>;
    private readonly addressChartSubject: Subject<any>;
  
    constructor() {
      this.locationChartSubject = new Subject<any>();
      this.addressChartSubject = new Subject<any>();
    }
  
    emitLocationChartEvent(chartInstance: any): void {
      this.locationChartSubject.next(chartInstance);
    }
  
    getLocationChartSubject(): Observable<any> {
      return this.locationChartSubject.asObservable();
    }
  
    emitAddressChartEvent(chartInstance: any): void {
      this.addressChartSubject.next(chartInstance);
    }
  
    getAddressChartSubject(): Observable<any> {
      return this.addressChartSubject.asObservable();
    }
  
    options: EChartsOption = {
      height: '80%',
      animation: false,
      animationDuration: 0,
      animationDurationUpdate: 0,
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985'
          }
        },
        valueFormatter: (value: any) => ClimateChartHelper.formatChartValue(value)
      },
      legend: { top: 10 },
      toolbox: ClimateChartHelper.getToolboxConfig('TXx Score', 'TXx_Score'),
      dataZoom: {
        show: false,
        start: 0,
        end: 100
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: ClimateChartHelper.getDualXAxisConfig({
        type: 'category',
        boundaryGap: ['10%', '10%'],
        axisLabel: { interval: 0 }
      }),
      yAxis: [
        {
          type: 'value',
          scale: true,
          name: 'Score',
          position: 'left',
          alignTicks: true,
          axisLine: {
            show: true,
          },
          axisLabel: {
            formatter: '{value}'
          },
          boundaryGap: [0.2, 0.2]
        }
      ],
      series: [],
      dataset: {}
    };
  
    updateTxxScoreChart(echartsInstance: any, climateChart: ClimateChart) {
      const chartConfig: ChartConfig = climateChart.chartConfig;
      const yAxis: YAxis = chartConfig.yAxis;
      const seriesData = [];
      const source = [];
  
      source.push(climateChart.xAxis);
  
      for (const [key, value] of Object.entries(climateChart.series)) {
        // Enable dual xAxis for Historical bar centering
      seriesData.push(ClimateChartHelper.getSeriesConfig(key, chartConfig.type, getSSPColor, true));
        // Use common method to pad SSP scenario data
        source.push(ClimateChartHelper.padSSPScenarioData(key, value, climateChart.xAxis));
      }
  
      echartsInstance.setOption({
        animation: false,
        animationDuration: 0,
        animationDurationUpdate: 0,
        xAxis: ClimateChartHelper.getDualXAxisConfig({
          type: 'category',
          boundaryGap: ['10%', '10%'],
          axisLabel: { interval: 0 }
        }),
        yAxis: [
          {
            type: 'value',
            scale: true,
            name: yAxis.title || 'Score',
            min: 0,
            max: 5,
            interval: yAxis.interval,
            position: 'left',
            alignTicks: true,
            axisLine: {
              show: true,
            },
            axisLabel: {
              formatter: '{value} '
            }
          }
        ],
        dataset: {
          source: source
        },
        series: seriesData
      });
    
    // Attach download handler to add title only when downloading
    ClimateChartHelper.attachDownloadHandler(echartsInstance, 'Heat Stress - Maximum of daily maximum temperature (TXx)', 'Heat_Stress_Maximum_of_daily_maximum_temperature_TXx_Score');
      if (echartsInstance && typeof echartsInstance.on === 'function') {
        let applying = false;
        try { echartsInstance.off && echartsInstance.off('finished'); } catch {}
        echartsInstance.on('finished', () => {
          if (applying) return;
          applying = true;
          echartsInstance.setOption({
            xAxis: ClimateChartHelper.getDualXAxisConfig({
              type: 'category',
              boundaryGap: ['10%', '10%'],
              axisLabel: { interval: 0 }
            })
          }, { replaceMerge: ['xAxis'] });
          setTimeout(() => { applying = false; }, 0);
        });
      }
    }
}
